import React from 'react'

export const Error = ({msg,className}) => {
  return (
    <span className={className ? className :'error-msg'}>{msg}</span>
  )
}
